import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Toast = ({ show, message, type, title = 'Success!', onClose }) => {

    useEffect(() => {
        let timer;
        if (show) {
            timer = setTimeout(() => {
                if (onClose) {
                    onClose();
                }
            }, 5000);
        }
        return () => clearTimeout(timer);
    }, [show, onClose]);

    if (!show) return null;

    const styles = {
        position: 'fixed',
        top: '20px',
        right: '20px',
        backgroundColor: type === 'success' ? '#d4edda' : '#f8d7da',
        padding: '12px 20px',
        borderRadius: '6px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        maxWidth: '350px',
        minWidth: '300px',
        fontSize: '14px',
        border: `1px solid ${type === 'success' ? '#4CAF50' : 'rgba(229, 115, 115, 1)'}`,
        color: type === 'success' ? '#448444' : '#ce2525'
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '8px',
        right: '12px',
        cursor: 'pointer',
        fontSize: '18px',
        lineHeight: '1',
        color: 'black',
    };

    // const titleStyle = {
    //     margin: '0',
    //     fontWeight: 'bold',
    // };

    const messageStyle = {
        margin: '4px 0 0',
        fontWeight: 'normal',
    };

    const hrStyle = {
        border: '0',
        borderTop: '1px solid black',
        margin: '8px 0',
    };

    return (
        <div style={styles}>
            <span style={closeButtonStyle} onClick={onClose}>
                ×
            </span>
        <div>
        <h4>{title}</h4>
        <hr style={hrStyle} />
        <p style={messageStyle}>{message}</p>
      </div>
    </div>
  );
};

Toast.propTypes = {
    show: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error']).isRequired,
    title: PropTypes.string,
    onClose: PropTypes.func
};

Toast.defaultProps = {
    title: 'Success!',
    onClose: () => {}
};

export default Toast;
